export default theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        flex: '1 1 0',
        width: '100%',
      },
    },
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: theme.spacing(12),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8),
    },
  },
  title: {
    paddingBottom: theme.spacing(2),
    fontWeight: 400,
    textTransform: 'initial',
  },
  image: {
    width: '100%',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      height: 400,
    },
  },
});
